import AppIcon from '../AppIcon';
import './style.css';

const AppPageLoader = ({ size = 40, className }: { size?: number; className?: string }) => {
  return (
    <div className={className || 'app-page-loader'}>
      <AppIcon icon="eos-icons:loading" width={size} />
    </div>
  );
};

export default AppPageLoader;
